import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MastersModule } from './masters/masters.module'
import { SpraModule } from './spra/spra.module';


@NgModule({
    declarations: [
    ],
    imports: [
        CommonModule,
        MastersModule.forRoot(),
        SpraModule.forRoot()
    ]
})
export class ComponentModule {
    static forRoot(): ModuleWithProviders<ComponentModule> {
        return {
            ngModule: ComponentModule
        }
    }
}
